(() => {
  if (window.atmAdvisorSearchInit) return;
  window.atmAdvisorSearchInit = true;

  const init = (form) => {
    const input = form.querySelector('.atm-advisor-search__input');
    const box = form.querySelector('.atm-advisor-search__results');
    let timer;
    let controller;

    const close = () => {
      box.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    };

    const render = (q, articles) => {
      box.replaceChildren();
      if (!articles.length) {
        const p = document.createElement('p');
        p.className = 'atm-advisor-search__empty';
        p.textContent = form.dataset.noResults;
        box.append(p);
      }
      articles.forEach((a) => {
        const link = document.createElement('a');
        link.className = 'atm-advisor-search__hit';
        link.href = a.url;
        link.setAttribute('role', 'option');
        link.textContent = a.title;
        box.append(link);
      });
      const all = document.createElement('button');
      all.type = 'submit';
      all.className = 'atm-advisor-search__all';
      all.textContent = form.dataset.seeAll.replace('%s', q);
      box.append(all);
      box.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    };

    const query = async () => {
      const q = input.value.trim();
      if (q.length < 2) return close();
      if (controller) controller.abort();
      controller = new AbortController();
      const params = new URLSearchParams({
        q,
        'resources[type]': 'article',
        'resources[limit]': '6',
        'resources[options][fields]': 'title,body,tag',
      });
      try {
        const res = await fetch(`${form.dataset.suggestUrl}.json?${params}`, { signal: controller.signal });
        const data = await res.json();
        render(q, data.resources?.results?.articles || []);
      } catch (e) {
        if (e.name !== 'AbortError') close();
      }
    };

    input.addEventListener('input', () => {
      clearTimeout(timer);
      timer = setTimeout(query, 200);
    });
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowDown' && !box.hidden) {
        e.preventDefault();
        box.querySelector('a, button')?.focus();
      }
    });
    box.addEventListener('keydown', (e) => {
      const items = [...box.querySelectorAll('a, button')];
      const i = items.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); items[Math.min(i + 1, items.length - 1)]?.focus(); }
      if (e.key === 'ArrowUp') { e.preventDefault(); (i <= 0 ? input : items[i - 1]).focus(); }
      if (e.key === 'Escape') { close(); input.focus(); }
    });
    document.addEventListener('click', (e) => {
      if (!form.contains(e.target)) close();
    });
  };

  const boot = () => document.querySelectorAll('[data-atm-advisor-search]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
